import React from "react";
import TextBlock from "../../LayoutBlocks/TextBlock/TextBlock";
import TitleBlock from "../../LayoutBlocks/TitleBlock/TitleBlock";
import styles from "./Double.module.css";

export default function Double({ id, data, onChange }) {
	const onTitleChange = (value) => {
		onChange({
			...data,
			title: value,
		});
	};

	const onContentOneChange = (value) => {
		onChange({
			...data,
			contentOne: value,
		});
	};

	const onContentTwoChange = (value) => {
		onChange({
			...data,
			contentTwo: value,
		});
	};

	const alignTitle = (alignment) => {
		onChange({
			...data,
			alignTitle: alignment,
		});
	};

	const alignContentOne = (alignment) => {
		onChange({
			...data,
			alignContentOne: alignment,
		});
	};

	const alignContentTwo = (alignment) => {
		onChange({
			...data,
			alignContentTwo: alignment,
		});
	};

	return (
		<div id={id} className={styles.double}>
			<TitleBlock
				title={data.title}
				onChange={onTitleChange}
				alignment={data.alignTitle}
				changeAlignment={alignTitle}
			/>
			<div className={styles.doubleContent}>
				<TextBlock
					content={data.contentOne}
					onChange={onContentOneChange}
					alignment={data.alignContentOne}
					changeAlignment={alignContentOne}
				/>
				<TextBlock
					content={data.contentTwo}
					onChange={onContentTwoChange}
					alignment={data.alignContentTwo}
					changeAlignment={alignContentTwo}
				/>
			</div>
		</div>
	);
}
